const apiVersion = 'v1';

const deleteStrategy = async (strategy) => {
  const data = {
    siteId: strategy.siteId,
    name: strategy.name,
  };
  try {
    const result = await window.axios.delete(`/${apiVersion}/strategy/delete`, {
      data,
    });
    return result.data.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const toggleActivateStrategy = async (strategy) => {
  try {
    await window.axios.put(
      `/${apiVersion}/strategy/${encodeURIComponent(strategy.name)}/activate`,
      strategy
    );
  } catch (err) {
    return Promise.reject(err);
  }
};

/**
 * Gets strategy replay info for an existing run
 * @param {number} strategyId
 * @param {number} logId
 * @returns {object} with keys:
 * - rule: editorData, ruleData, sourceData -- feed the Code Effects editor
 * - inputType: the FQN of the input for the strategy run
 * - inputName: friendly name of the input
 * - inputData: the original input data used for the strategy run
 */
const getStrategyReplayById = async (strategyId, logId) => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/strategy/${strategyId}/history/${logId}`
    );
    const { data } = result.data;
    data.inputData = JSON.parse(data.serializedExecutionData);
    data.dataSources = JSON.parse(data.serializedDataSources);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

/**
 *
 * @param {object} payload - has the following keys:
 *   - ruleContent - the content of the rule
 *   - inputData - the values of the input in key-value pairs
 * @returns {array} - the results of the execution. An array
 *   of objects with keys message (string) and messageType (string).
 */
const replayStrategy = async (strategyId, payload) => {
  try {
    const result = await window.axios.post(
      `/${apiVersion}/strategy/what-if`,
      payload
    );
    return result.data.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  deleteStrategy,
  toggleActivateStrategy,
  getStrategyReplayById,
  replayStrategy,
};
